module.exports = __webpack_public_path__ + "img/team.e934a8d9.png";